import { ThunkAction } from '@reduxjs/toolkit';

import { rootReducer } from './config';

import createTicketsSlice from './modules/tickets/slices';
import createHelpCenterSlice from './modules/helpCenter/slices';
import createSearchSlice from './modules/search/slices';
import createNotificationsSlice from './modules/notifications/slices';
import createModalsSlice from './modules/modals/slices';
import createChatsSlice from './modules/chats/slices';
import createFaqSlice from './modules/faq/slices';
import createReleaseNotesSlice from './modules/releaseNotes/slices';

import * as ticketsSelectors from './modules/tickets/selectors';
import * as helpCenterSelectors from './modules/helpCenter/selectors';
import * as searchSelectors from './modules/search/selectors';
import * as notificationsSelectors from './modules/notifications/selectors';
import * as modalsSelectors from './modules/modals/selectors';
import * as chatsSelectors from './modules/chats/selectors';
import * as faqSelectors from './modules/faq/selectors';
import * as releaseNotesSelectors from './modules/releaseNotes/selectors';

import * as ticketsActions from './modules/tickets/actions';
import * as helpCenterActions from './modules/helpCenter/actions';
import * as searchActions from './modules/search/actions';
import * as notificationsActions from './modules/notifications/actions';
import * as chatsActions from './modules/chats/actions';
import * as faqActions from './modules/faq/actions';
import * as releaseNotesActions from './modules/releaseNotes/actions';

import { initialState as ticketsInitialState } from './modules/tickets/slices';
import { initialState as helpCenterInitialState } from './modules/helpCenter/slices';
import { initialState as searchInitialState } from './modules/search/slices';
import { initialState as notificationsInitialState } from './modules/notifications/slices';
import { initialState as modalsInitialState } from './modules/modals/slices';
import { initialState as chatsInitialState } from './modules/chats/slices';
import { initialState as faqInitialState } from './modules/faq/slices';
import { initialState as releaseNotesInitialState } from './modules/releaseNotes/slices';

import helpCenterApi from '@sv-support-sdk/api/src/modules/helpCenter';
import ticketsApi from '@sv-support-sdk/api/src/modules/tickets';
import chatsApi from '@sv-support-sdk/api/src/modules/chats';
import faqApi from '@sv-support-sdk/api/src/modules/faq';
import releaseNotesApi from '@sv-support-sdk/api/src/modules/releaseNotes';
import searchApi from '@sv-support-sdk/api/src/modules/search';

import { setupApiInstance } from '@sv-support-sdk/api/src/instance';

// this instance is just for typing
const instance = setupApiInstance({ baseURL: '' });

const api = {
  releaseNotes: releaseNotesApi(instance),
  helpCenter: helpCenterApi(instance),
  tickets: ticketsApi(instance),
  chats: chatsApi(instance),
  faq: faqApi(instance),
  search: searchApi(instance)
}

export type RootState = ReturnType<typeof rootReducer>;
export type TThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, typeof api, any>;

export {
  createTicketsSlice,
  createHelpCenterSlice,
  createSearchSlice,
  createNotificationsSlice,
  createModalsSlice,
  createChatsSlice,
  createFaqSlice,
  createReleaseNotesSlice,
  //
  ticketsSelectors,
  helpCenterSelectors,
  searchSelectors,
  notificationsSelectors,
  modalsSelectors,
  chatsSelectors,
  faqSelectors,
  releaseNotesSelectors,
  //
  ticketsInitialState,
  helpCenterInitialState,
  searchInitialState,
  notificationsInitialState,
  modalsInitialState,
  chatsInitialState,
  faqInitialState,
  releaseNotesInitialState,
  //
  ticketsActions,
  helpCenterActions,
  searchActions,
  notificationsActions,
  chatsActions,
  faqActions,
  releaseNotesActions,
};
